/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Sign_PcInputs */

const en_pc_cmp_r_sign_pc = /** @type {(inputs: Pc_Cmp_R_Sign_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic digital signatures, no send-and-collect workflow`)
};

const zh_pc_cmp_r_sign_pc = /** @type {(inputs: Pc_Cmp_R_Sign_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础数字签名，暂无发起与收集流程`)
};

/**
* | output |
* | --- |
* | "Basic digital signatures, no send-and-collect workflow" |
*
* @param {Pc_Cmp_R_Sign_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_sign_pc = /** @type {((inputs?: Pc_Cmp_R_Sign_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Sign_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_sign_pc(inputs)
	return zh_pc_cmp_r_sign_pc(inputs)
});
export { pc_cmp_r_sign_pc as "pc.cmp.r.sign.pc" }